import api from "../base";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type GetProjectsOptions = {
    page?: number;
    perPage?: number;
};

export async function getProjects({ page = 1, perPage = 10 }: GetProjectsOptions) {
    const response = await api.get("/projects/", {
        params: {
            page: page,
            per_page: perPage,
        }
    });
    return response.data;
}

export const useGetProjects = ({ page = 1, perPage = 10, config = {} }) => {
    return useQuery({
        ...config,
        queryKey: ["projects", page, perPage],
        queryFn: async () => {
            const data = await getProjects({ page, perPage });
            // If there are no results, retry up to 3 times
            if (data?.results?.length === 0) {
                let attempts = 1;
                while (attempts < 3) {
                    const retryData = await getProjects({ page, perPage });
                    if (retryData?.results?.length > 0) {
                        return retryData;
                    }
                    attempts++;
                    // Wait 1 second before retrying
                    await new Promise(resolve => setTimeout(resolve, 1500));
                }
            }
            return data;
        },
        placeholderData: keepPreviousData,
        staleTime: 1000 * 60 * 10, // 10 minutes
    });
};
